module.exports = __webpack_public_path__ + "static/media/SCOT.340856ec.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/currency-icons/SCOT.svg
// module id = 620
// module chunks = 0